( function () {
    const checkoutWarningElement = document.querySelector( '#checkout-warning' );
    const checkoutWarningToggleElement = document.querySelector( '#checkout-warning-toggler' );

    checkoutWarningToggleElement && checkoutWarningToggleElement.addEventListener( 'click', e => {
        e.preventDefault();

        if ( checkoutWarningElement ) {
            checkoutWarningElement.classList.toggle( 'ts-checkout-warning-open' );
        }
    } );
} )();
